/**
 * Labstep
 *
 * @module grid/NewIndex/components/ToolPanel/EntityUsers
 * @desc Wizard to add a column
 */

import { EntitySearchMulti } from 'labstep-web/components/Entity/Search/Multi';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponent } from 'labstep-web/core/Action/Component';
import { Flex } from 'labstep-web/core/Flex';
import { Header, SectionHeader } from 'labstep-web/core/Header';
import { colDefEntityEntityUsers } from 'labstep-web/grid/NewIndex/coldefs/entity/entity-users';
import { getColDefEntityEntityUsersEntityUserRole } from 'labstep-web/grid/NewIndex/coldefs/experiment-workflow/entity-users-entity-user-role';
import { ToolPanelState } from 'labstep-web/grid/NewIndex/components/ToolPanel';
import { EntityDataGridToolPanelListItem } from 'labstep-web/grid/Report/components/ToolPanel/ListItem';
import { EntityUserRole } from 'labstep-web/models/entity-user-role.model';
import type React from 'react';
import type { IEntityDataGridToolPanelEntityUserRolesProps } from './types';

export const EntityDataGridToolPanelEntityUserRoles: React.FC<
  IEntityDataGridToolPanelEntityUserRolesProps
> = ({ colIds, gridNewIndexService, setToolPanelState }) => (
  <div>
    <Flex vAlignContent="center" spacing="gap" shrink={0}>
      <ActionComponent
        type="icon"
        icon="arrow left"
        text="Go Back"
        onClick={() => setToolPanelState(ToolPanelState.add_column)}
      />
      <Header size="tiny" noMargin>
        Collaborators
      </Header>
    </Flex>
    <small>Select a role</small>
    <EntitySearchMulti
      staticLists={(searchQuery) => (
        <>
          <EntityDataGridToolPanelListItem
            icon={ICONS.user.secondary}
            actionIcon="eye"
            text={'All collaborators'}
            onClick={() => {
              if (gridNewIndexService) {
                gridNewIndexService.addColumnDef(
                  colDefEntityEntityUsers,
                );
              }
            }}
            disabled={colIds.includes(colDefEntityEntityUsers.colId)}
          />
        </>
      )}
      lists={[
        {
          key: EntityUserRole.entityName,
          entityName: EntityUserRole.entityName,
          searchField: 'name_like',
          params: {
            group_by_name: true,
          },
          header: <SectionHeader label="Roles" />,
          listItem: (entity: object) => (
            <EntityDataGridToolPanelListItem
              icon={ICONS.user.primary}
              actionIcon="eye"
              text={(entity as EntityUserRole).name}
              onClick={() => {
                if (gridNewIndexService) {
                  gridNewIndexService.addColumnDef(
                    getColDefEntityEntityUsersEntityUserRole(
                      (entity as EntityUserRole).name,
                    ),
                  );
                }
              }}
              disabled={colIds.includes(
                getColDefEntityEntityUsersEntityUserRole(
                  (entity as EntityUserRole).name,
                ).colId || '',
              )}
            />
          ),
        },
      ]}
    />
  </div>
);
